import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const defaultForm: IForm = {
    formId      : PublishedFormId.Default,
    type        : FormTypeId.Default,
    fieldsOrder : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.Description,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        description: {
            value: undefined,
        },
        additionalData: additionalDataFactory({
            hasComment         : false,
            hasQuantity        : false,
            budgetMin          : 1000,
            budgetMax          : 60000,
            budgetDefaultValue : 6000,
            marks              : budgetMarksBuilder(1000, 500, 25000, 1000, 60000),
        }),
        contact: fieldsContact,
    },
};

export default defaultForm;
